<template>
  <div>
    <div class="mt-3 period-selector">
      <b-button-group>
        <span v-for="(intervalButton, index) in intervalButtons" :key="'intervalButton-' + index">
          <b-button
              class="internal-button"
              :variant="intervalButton.active ? 'active' : ''"
              @click="changeInterval(intervalButton)"
              :key="updateKey"
          >
            {{ $cte(intervalButton.label) }}
          </b-button>
        </span>
      </b-button-group>
    </div>
    <h3 class="text-center" v-if="errorMsg" style="color: red">
      {{ errorMsg }}
    </h3>

      <b-overlay class="mt-3 mb-3 custom-blur"
                 :show="overlayErrorMsg"
                 :blur="'3px'"
                 :spinner-type="'none'"
                 :variant="'none'">
        <span class="period-label font-poppins"> {{ $cte("flatRate.informText") }} </span>
        <div class="d-flex flex-row align-items-center align-items-stretch mt-3 reportSliderContainer" >
          <div class="paging-div mr-4 desktop-only"  @click="pageLeft">
            <i class="fas fa-angle-left"></i>
          </div>
          <div class="mt-4 relative w-100">
            
            <div class=" justify-content-center spacing mb-4 desktop-only">
              <div v-if="activeInterval === 'yearly'" class="title" >{{yearPointer}}</div>
              <div v-if="activeInterval === 'quarterly'" class="title" >{{yearPointer}} {{hungarianQuarters[quarterPointer]}}</div>
            </div>

            <div class="mobile-only">
              <div class="d-flex flex-row align-items-center align-items-stretch spacing-2 card-container" >
                <div class="paging-div mr-4"  @click="pageLeft">
                  <i class="fas fa-angle-left"></i>
                </div>
                <div class="mt-4 relative container-style">
                  <div class="d-flex justify-content-center spacing mb-4">
                    <div v-if="activeInterval === 'yearly'" class="title" >{{yearPointer}}</div>
                    <div v-if="activeInterval === 'quarterly'" class="title" >{{yearPointer}} {{hungarianQuarters[quarterPointer]}}</div>
                  </div>
                </div>
                <div
                class="paging-div ml-4"
                @click="pageRight"
                >
                  <i class="fas fa-angle-right"></i>
                </div>
              </div>
            </div>

            <b-container class="card-parent" fluid>
              <b-row>
                <b-col cols="12" xl="6">
              <!-- Bevétel -->
                  <income-card 
                    :selectedMode="activeInterval"
                    :selectedMonths="selectedMonths"
                    :selectedYear="data58.annual"
                  /> 
                </b-col>
                
                <!-- Fizetendő adó és járulék -->
                <b-col cols="12" xl="6">  
                  <atalany-card
                    :selectedMode="activeInterval"
                    :selectedQuarterData="selectedQuarterData"
                    :selectedYearData="data58.annual"
                  />
                </b-col>
              </b-row>
            </b-container>
         </div>
          <div
            @click="pageRight"
            class="paging-div desktop-only"
          >
            <i class="fas fa-angle-right"></i>
          </div>
      </div>

      <div v-if="hasAnyDiscount" class="mt-4 discounts-section">
        <h5 class="discounts-title">Igénybevett kedvezmények</h5>
        <ul class="discount-list">
          <li v-if="activeDiscountData.discountOfMotherOfFourOrMoreUsed">
            <i class="fas fa-check text-success mr-2"></i>
            Négy vagy több gyereket nevelő anyák kedvezménye
          </li>
          <li v-if="activeDiscountData.discountOfMotherOfTwoUsed">
            <i class="fas fa-check text-success mr-2"></i>
            Két gyerekes anyák SZJA kedvezménye
          </li>
          <li v-if="activeDiscountData.discountOfAgeUnder25Used">
            <i class="fas fa-check text-success mr-2"></i>
            25 év alatti fiatalok kedvezménye
          </li>
          <li v-if="activeDiscountData.discountMotherUnder30Used">
            <i class="fas fa-check text-success mr-2"></i>
            30 év alatti anyák kedvezménye
          </li>
          <li v-if="activeDiscountData.discountPersonalUsed">
            <i class="fas fa-check text-success mr-2"></i>
            Személyi kedvezmény
          </li>
          <li v-if="activeDiscountData.discountOfFirstMarriageUsed">
            <i class="fas fa-check text-success mr-2"></i>
            Első házasok kedvezménye
          </li>
          <li v-if="activeDiscountData.familyDiscountUsed">
            <i class="fas fa-check text-success mr-2"></i>
            Családi kedvezmény
          </li>
        </ul>
      </div>

      <template #overlay>
        <div class="font-weight-bold" style="">
          <b-card bg-variant="warning p-3 shadow-lg">{{ overlayErrorMsg }}</b-card>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AtalanyCard from "@/views/app/invoicing/AtalanyCard";
import IncomeCard from "@/views/app/invoicing/IncomeCard";
import Api from "api-client/index";

export default {
  name: "AtalanyView",

  components: { AtalanyCard, IncomeCard },
  props: ["selectedYear", "selectedQuarter"],
  watch: { 
    selectedYear: function() {
      this.get58();
    },
    selectedQuarter: function(newVal) {
      this.selectedQuarterData = this.data58.quarters.find(i => i.quarterOrder === newVal.value);
      this.selectedMonths = this.data58.months.filter((i) => {
        for (let j = this.selectedQuarter.value * 3; j < this.selectedQuarter.value * 3 + 3; j++) {
          if(j === i.monthOrder) {
            return true;
          }
        }
      })
    }
  },

  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
    activeDiscountData() {
      return this.activeInterval === 'yearly'
        ? this.data58.annual
        : this.selectedQuarterData;
    },
    hasAnyDiscount() {
      const data = this.activeDiscountData;
      if (!data) return false;
      return data.discountOfMotherOfFourOrMoreUsed ||
             data.discountOfMotherOfTwoUsed ||
             data.discountOfAgeUnder25Used ||
             data.discountMotherUnder30Used ||
             data.discountPersonalUsed ||
             data.discountOfFirstMarriageUsed ||
             data.familyDiscountUsed;
    }
  },

  data() {
    return {
      errorMsg: null,
      overlayErrorMsg: null,
      loaded: false,

      currentYear: new Date().getFullYear(),
      yearPointer: new Date().getFullYear(),
      quarterPointer:
        new Date().getMonth() % 3,
      actualMonth: new Date().getMonth(),
      annualSummary: {},
      data58: {},
      selectedQuarterData: {},
      selectedMonths: [],
      intervalButtons: [
        {
          label: "vat.quarterly",
          active: true,
          value: "quarterly",
        },
        {
          label: "vat.annual",
          active: false,
          value: "yearly",
        },
        
      ],
      hungarianQuarters : [
        "I. negyedév",
        "II. negyedév",
        "III. negyedév",
        "IV. negyedév"
      ],
      activeInterval: "quarterly",
      updateKey: 0
    };
  },

  created() {
    this.get58();
  },

  methods: {
    changeInterval(intervalData) {
      this.intervalButtons.forEach((button) => {
        button.active = false;
      });

      this.activeInterval = intervalData.value;
      intervalData.active = true;

      
      this.get58();
    },

    pageLeft() {
      if(this.activeInterval === "quarterly") {
        if ((this.yearPointer === 2023 && this.quarterPointer === 0) || this.yearPointer < 2023) {
          return;
        }

        if (this.quarterPointer <= 0) {
          this.yearPointer = this.yearPointer - 1;
          this.quarterPointer = 3;
        } else {
          this.quarterPointer = this.quarterPointer - 1;
        }
      }

      if(this.activeInterval === "yearly") {
        if (this.yearPointer <= 2023) {
          return;
        }

        this.yearPointer = this.yearPointer - 1;
      }
      this.get58();

    },

    pageRight() {
      if(this.activeInterval === "quarterly") {
        if (this.currentYear === this.yearPointer && this.quarterPointer >= 3) {
          return;
        }

        if (this.quarterPointer >= 3) {
          this.yearPointer = this.yearPointer + 1;
          this.quarterPointer = 0;
        } else {
          this.quarterPointer = this.quarterPointer + 1;
        }
      }
      if(this.activeInterval === "yearly") {
        if (this.currentYear === this.yearPointer) {
          return;
        }
        this.yearPointer = this.yearPointer + 1;
      } 

      this.get58();
    },

    calculateOffsetYearPointer(year, month, offset) {
      if (month + offset > 11) {
        return year + 1;
      }
      return year;
    },

    get58() {
      Api.getPayableTaxes(this.getActiveCompany.id, this.yearPointer).then((resp) => {
        this.overlayErrorMsg = null;
        this.data58 = resp.data;
        this.selectedQuarterData = this.data58.quarters.find(i => i.quarterOrder === this.quarterPointer) || {};
        this.selectedMonths = this.data58.months.filter((i) => {
          for (let j = this.quarterPointer * 3; j < this.quarterPointer * 3 + 3; j++) {
            if (j === i.monthOrder) {
              return true;
            }
          }
          return false;
        })

        this.loaded = true;
      }).catch((err) => {
        this.data58 = {};
        this.selectedQuarterData = {};
        this.selectedMonths = [];
        if (err?.response?.data?.message) {
          // this.overlayErrorMsg = err?.response?.data?.message;
          alert(err?.response?.data?.message);
        } else {
          alert('Hálózati hiba');
        }
      });
    }
  },
};
</script>

<style scoped>
.custom-blur >>> .b-overlay div:first-child {
  opacity: 1 !important;
}

.progress {
  height: 30px;
  margin-bottom: 5px;
  background-color: #2ab951;
}

.progress-bar {
  background-color: #008200;
}

.inform-text {
  font-family: Poppins;
  font-weight: bold;
  color: #b5b5c4;
  margin: 0 3.2rem;
}

.internal-button {
  min-width: 100%;
}

.period-selector {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: #252734;
  border-radius: 32px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.period-selector::-webkit-scrollbar {
  display: none;
}

.period-selector >>> .btn-group {
  display: inline-flex;
  flex-wrap: nowrap;
  min-width: max-content;
}

.period-selector >>> .btn-group > span,
.period-selector >>> .btn-group .btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

.card-parent {
  width: 100%;
}

.paging-div {
  padding: 0.6rem;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  color: #b2ec5d;
  background-color: #252734;
  font-size: 1rem;
  border-radius: 22px;
  cursor: pointer;
}

.paging-div:hover {
  background-color: #b2ec5d !important;
  color: #252734 !important;
}

.paging-div.disabled {
  color: gray;
}

.data {
  background-color: #f3f6f9;
}
.footnote {
  text-align: right;
  margin-right: 3rem;
  color: #b2ec5d;
  font-weight: bold;
  font-size: 0.9rem;
}

@media screen and (max-width: 1246px) {
  .inform-text {
    margin: 0;
  }

  .footnote {
    font-size: 1.1rem;
  }
}

/* Remove padding by default */
.custom-padding {
  padding: 0.2rem; 
}


/* Remove padding again on lg viewport */
@media (min-width: 992px) {
  .custom-padding {
    padding: 0;
  }
}

.period-label {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.52);
}

.title {
  font-family: Jumper;
  font-size: 2rem;
  text-align: center;
  width: 100%;
  padding: 0.25rem;
  margin: 0 0.8rem;
  margin-bottom: 0.25rem;
  border: none;
  max-width: 400px;
}
.card-body {
  width: 100%;
  padding-left: 4rem !important;
  padding-right: 4rem !important;
  margin: 0 auto;
}
.desktop-only {
  display: none;
}
@media screen and (min-width: 1246px) {
  .desktop-only { 
    display: flex;
  }
}
.card-container {
  width: fit-content;
  margin: 0 auto;
}
.mobile-only {
  display: none;
}

@media screen and (max-width: 1246px) {

  .card-body {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
    margin: 0 auto;
  }
  .mobile-only {
    display: flex;
  }
}

.reportSliderContainer {
  border: 1px solid #252734;
  border-radius: 32px;
  padding: 20px;
}

.discounts-section {
  background-color: #252734;
  border-radius: 12px;
  padding: 1rem 1.5rem;
}

.discounts-title {
  color: #B2EC5D;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.discount-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.discount-list li {
  padding: 0.5rem 0;
  color: #B2EC5D;
}

.discount-list li i {
  font-size: 0.9rem;
}
</style>
